import { axiosInstance } from "@/api/apiClient";
import {
  DialGroupApi,
  DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest,
  DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest,
  DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest,
  DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new DialGroupApi(undefined, BASE_API, axiosInstance);

export const getAutomatedVoiceGreetings = async (
  payload: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest
) => {
  return api.telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings.bind(
    api
  )(payload);
};

export const getVoiceAccents = async (
  payload: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest
) => {
  return api.telephonyViewsNinjaNumberCallConfigurationListVoiceAccents.bind(
    api
  )(payload);
};

export const createAutomatedGreeting = async (
  payload: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest
) => {
  return api.telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting.bind(
    api
  )(payload);
};

export const getCallConfigDialGroup = async (
  payload: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest
) => {
  return api.telephonyViewsNinjaNumberCallConfigurationListDialGroup.bind(api)(
    payload
  );
};
